import { render, staticRenderFns } from "./ykc-button.vue?vue&type=template&id=bcbba30a&"
import script from "./ykc-button.vue?vue&type=script&lang=js&"
export * from "./ykc-button.vue?vue&type=script&lang=js&"
import style0 from "./ykc-button.vue?vue&type=style&index=0&id=bcbba30a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports